export default __webpack_public_path__ + "static/media/karla.61d21d81.png";